export default "__VITE_PUBLIC_ASSET__9b51a1b6__"